import type { ReactNode } from "react";
import { useMe } from "./hooks";
import { LoadingAnimation } from "@/components/molecules/LoadingAnimation";

/**
 * Держит детей, пока сессия не определилась. Рендерится ВНУТРИ
 * QueryClientProvider — иначе useMe не найдёт клиента.
 *
 * Ошибка тоже считается определившимся состоянием: 404 (на стендах
 * %%API_URL%% ещё указывает на /graphql — флип вынесен в Debt), 5xx или
 * обрыв сети не должны оставлять виджет навсегда на прелоадере. Дальше
 * пользователь увидит честное «временно недоступно» от DataLoader.
 */
export function SessionBootstrap({ children }: { children: ReactNode }) {
  const { isLoading, isError } = useMe();

  if (isLoading && !isError) {
    return <LoadingAnimation size="large" color="primary" backdrop loading />;
  }

  return <>{children}</>;
}
